module.exports = __webpack_public_path__ + "static/media/register-animation.cac7b6e7.lottie";